package com.mps.asc_app.domain.places.mapper

import com.mps.asc_app.data.places.model.AddressDto
import com.mps.asc_app.domain.places.model.Address

fun AddressDto.toAddress(): Address {
    return Address(
        formattedAddress = formattedAddress,
        street = street,
        postalCode = postalCode,
        city = city,
        country = country,
        placeId = placeId,
        lat = lat,
        lng = lng
    )
}